module.exports = __webpack_public_path__ + "97690172d2fd751f2f63f1ce112a6241.png";